<template>
  <div class="row custom-radio-buttom-container">
    <div
      v-for="(item, index) in options"
      :key="'rbLegend' + index"
      class="custom-radio-buttom-item"
    >
      <div class="page-item">
        <div
          class="page-link custom-radio-buttom"
          :style="{ background: item.color }"
        >
          <span class="d-block text-center legend-number">
            {{ item.number }}
          </span>
          <div class="text-center">
            <span class="legend-label">{{ item.label }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'OptionLegendIndicator',
  data() {
    return {
      selectedAnswer: this.value,
    };
  },
  props: {
    options: {
      type: Array,
      default: () => [],
    },
    number: {
      type: String,
      default: () => '',
    },
    label: {
      type: String,
      default: () => '',
    },
  },
};
</script>

<style scoped>
.custom-radio-buttom-container {
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  margin-right: 0px;
  margin-bottom: -1px;
  margin-bottom: -2px;
}
.custom-radio-buttom {
  background-color: transparent;
  width: 85px;
}
.custom-radio-buttom:hover {
  background: none;
}
.legend-label {
  text-align: center;
  font-size: 16px;
  letter-spacing: 0px;
  color: #11291b;
}
.legend-number {
  text-align: center;
  font-size: 19px;
  letter-spacing: 0px;
  color: #11291b;
}
.page-link {
  border: 1px solid #fff;
}
</style>
